import { DateTime } from 'luxon';
import IPhoneIcon from '@app/assets/icons/iphone.svg?react';
import EmailIcon from '@app/assets/icons/mail-box.svg?react';
import PlayIcon from '@app/assets/icons/play-white.svg?react';
import {getAutomationStatusColor} from '@app/utils/utils';
// import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import {AUTOMATION_STATUS_VALUE, AutomationInterface} from '@app/models/automations.ts';
import { capitalize } from 'lodash';

import { Button } from '@app/components/Button/Button';
import {AutomationMenu} from "@app/components/AutomationMenu/AutomationMenu.tsx";
import {pauseAutomation, startAutomation} from "@app/services/automations.ts";

export const AutomationsTableRow = ({
  data,
  onClick,
  refetch,
  onDelete,
  onCancel,
  isHighlighted,
  onHighlight,
  disabledActions,
}: {
  data: AutomationInterface;
  onClick?: () => void;
  refetch?: () => void;
  onDelete?: (automation: AutomationInterface) => void;
  onCancel?: (automation: AutomationInterface) => void;
  isHighlighted?: boolean;
  onHighlight?: (automationId: string) => void;
  disabledActions?: {
    deleteAutomation?: boolean;
    cancelAutomation?: boolean;
    pauseAutomation?: boolean;
  };
}) => {

  const canStart = data.status === AUTOMATION_STATUS_VALUE.PAUSED;

  return (
    <tr
      className={`border-b border-base-antiFlash last-of-type:border-b-0 text-xs cursor-pointer hover:bg-brand-lightBlue4 transition-all duration-300 ${isHighlighted ? 'border-2 border-green-500' : ''}`}
      onClick={onClick}
    >
      <td className="p-4" style={{ textAlign: 'left' }}>
        <div>
          <p className="font-bold">{data.name}</p>
          <p className="text-xs text-base-coolGray">#{data?.id}</p>
          <p className="text-xs text-base-coolGray">
            <span>Created on: </span>
            <span>{DateTime.fromISO(data.createdAt).toFormat('MMM dd, yyyy')}</span>
          </p>
        </div>
      </td>
      <td className="p-4">
        <div className="flex gap-2">
          <div className="flex gap-1 flex-col">
            {data?.channels?.split(',')?.map((t: string) =>
              t === 'email' ? (
                <div key={t} className="flex items-center gap-2">
                  <span className="bg-base-antiFlash p-1 rounded-sm flex items-center justify-center">
                    <EmailIcon className="w-4 h-4" />
                  </span>
                  <span>Email</span>
                </div>
              ) : (
                <div key={t} className="flex items-center gap-2">
                  <span className="bg-base-antiFlash p-1 rounded-sm flex items-center justify-center">
                    <IPhoneIcon className="w-4 h-4" />
                  </span>
                  <span>Text</span>
                </div>
              )
            )}
          </div>
        </div>
      </td>
      <td className="p-4" style={{ textAlign: 'left' }}>
        <span className="w-2 h-2 inline-block rounded-full mr-1" style={{ backgroundColor: getAutomationStatusColor(data?.status) }}></span>
        <span>{capitalize(data?.status ?? '')}</span>
      </td>
      <td className="p-4 text-right align-text-top">
        <span className="font-semibold text-base">{data.started}</span>
      </td>
      <td className="p-4 text-right align-text-top">
        <div className="font-semibold text-base">{data.completed}</div>
        {(data.started && data.completed) && (
          <div className="text-[#1E4A8B]">{Math.round((data.completed / data.started) * 100)}%</div>
        )}
      </td>
      <td className="p-4 text-end">
        <div className="flex items-center justify-end gap-2">
          {(canStart &&
            <Button
              onClick={async (e) => {
                e.preventDefault();
                e.stopPropagation();

                try {
                  const response = await startAutomation(data.id);
                  const startedAutomation = response.data.automation;
                  toast.success('Automation started successfully');
                  refetch?.();
                  onHighlight?.(startedAutomation.id);
                } catch (error) {
                  toast.error('Failed to start automation');
                }


              }}
              onlyIcon={true}
              kind="primary"
              className="rounded"
              title="Start automation"
            >
              <PlayIcon/>
            </Button>
          )}
          <AutomationMenu
            status={data.status}
            automationId={data.id}
            deleteAutomation={async () => {
              onDelete?.(data);
            }}
            cancelAutomation={async () => {
              onCancel?.(data);
            }}
            pauseAutomation={async () => {
              try {
                const response = await pauseAutomation(data.id);
                const pausedAutomation = response.data.automation;
                toast.success('Automation paused successfully');
                refetch?.();
                onHighlight?.(pausedAutomation.id);
              } catch (error) {
                toast.error('Failed to pause automation');
              }
            }}
            // cancelAutomation={async () => {
            //   try {
            //     console.log('cancel before', data);
            //     await cancelAutomation(data.id);
            //     toast.success('Automation cancelled successfully');
            //     refetch?.();
            //   } catch (error) {
            //     toast.error('Failed to cancel automation');
            //   }
            // }}
            continueCreating={async () => {
              onClick?.();
            }}
            disabledActions={disabledActions}
          />
        </div>
      </td>
    </tr>
  );
};
